import { Flex, Icon, Input } from '@chakra-ui/react';
import { RiSearchLine } from 'react-icons/ri';
import { search } from 'ss-search';

import { ClassifDTO } from '../../../dtos/ClassifDTO';

type ControlsData = {
	page: number;
	perPage: number;
	totalPage: number;
};

interface DTSearchParams {
	classifs: ClassifDTO[];
	setPesqClassifs: (classif: ClassifDTO[]) => void;
	controls: ControlsData;
	setControls: (control: ControlsData) => void;
	handleUpdateList: (
		page: number,
		perPage: number,
		classifs: ClassifDTO[],
	) => void;
};

const DTSearch: React.FC<DTSearchParams> = ({
	classifs,
	setPesqClassifs,
	controls,
	setControls,
	handleUpdateList,
}) => {

	function handlePesquisa(event: string) {
		const texto = event;

		if (texto === '' || texto === ' ') {
			setPesqClassifs(classifs);

			setControls({
				...controls,
				page: 1,
				totalPage: Math.ceil(classifs.length / controls.perPage),
			});

			handleUpdateList(1, controls.perPage, classifs);
			return;
		};

		const searchKeys = ['nome', 'doc', 'phone', 'cid'];
		const results = search(classifs, searchKeys, texto) as ClassifDTO[];

		setPesqClassifs(results);
		setControls({
			...controls,
			page: 1,
			totalPage: Math.ceil(results.length / controls.perPage),
		});

		handleUpdateList(1, controls.perPage, results);
	};

	return (
		<Flex as="form" ml={["0", "0", "4"]} mb={2}>
			<Flex
				as="label"
				flex="1"
				py="2"
				pl="2"
				pr="6"
				maxWidth={400}
				alignSelf="center"
				color="gray.900"
				position="relative"
				bg="gray.50"
				borderRadius="full"
			>
				<Input
					color="gray.900"
					variant="unstyled"
					px="4"
					mr="4"
					placeholder="Pesquisar"
					_placeholder={{ color: 'gray.400' }}
					onChange={e => handlePesquisa(e.target.value)}
				/>

				<Icon as={RiSearchLine} fontSize="20" color="blue.500" />
			</Flex>
		</Flex>
	);
};

export default DTSearch;